import './theme.less'

import {action, classes, Icon, Image, MediaQuery} from '@codeurs/front'
import m from 'mithril'
import {WysiwygType} from 'types/types'
import Layout from 'views/layout'
import ContentContainer from 'views/layout/contentcontainer'
import HorizontalScrollNav from 'views/layout/horizontalscrollnav'
import Link from 'views/layout/link'
import Title from 'views/layout/title'
import Wysiwyg from 'views/layout/wysiwyg'
import {ArticleType} from 'views/partials/features/articlelink'
import ArticlesContainer from 'views/partials/features/articlescontainer'
import {PublicationType} from 'views/partials/features/publicationlink'
import PublicationsContainer from 'views/partials/features/publicationscontainer'

type SubThemeType = {
	id: string
	title: string
	url: string
}

type ThemeType = {
	id: string
	title: string
	url: WysiwygType
	sub_menu?: Array<SubThemeType>
}

export default class Theme extends Layout<{
	title: string
	text: WysiwygType
	theme_menu: Array<ThemeType>
	parentId?: string
	related: {
		publications: Array<PublicationType>
		articles: Array<ArticleType>
	}
	featured_articles: Array<ArticleType>
	featured_publication: PublicationType
	lists: any
}> {
	view() {
		const {
			text,
			related,
			lists,
			featured_articles,
			featured_publication,
			title
		} = this.attrs.data
		const allTags = lists.tags
		return m('.theme', [
			this.viewMenu(),
			m('.theme-line'),
			this.viewSubMenu(),
			m(ContentContainer,
				m('.theme-content', [
					m(Title, {class: 'theme-content-title', heading: 2}, title),
					m(Wysiwyg, {html: text, class: 'theme-content-text'})
				]),
				related.publications[0] &&
					m(PublicationsContainer, {
						related,
						allTags,
						featured_publication,
						class: 'theme-content-publications'
					}),
				related.articles[0] &&
					m(ArticlesContainer, {related, featured_articles})
			)
		])
	}

	viewMenu() {
		const {theme_menu, id, parentId} = this.attrs.data
		const themeId = parentId ? parentId : id
		return m(HorizontalScrollNav, [
			theme_menu.map(theme => [
				m(MediaQuery, {
					maxWidth: 1023,
					view: () => this.viewTheme(theme, themeId, true)
				}),
				m(MediaQuery, {
					minWidth: 1024,
					view: () => this.viewTheme(theme, themeId, false)
				})
			])
		])
	}

	viewTheme(theme, themeId, scrollTo: boolean) {
		return m(Link,
			{
				...action(theme.url),
				...classes(
					{mod: 'anchors'},
					themeId == theme.id ? ' is-active activemenuitem' : ''
				),
				oncreate: vnode => {
					if (scrollTo) {
						themeId == theme.id
							? vnode.dom.scrollIntoView({behavour: 'smooth', inline: 'center'})
							: null
					}
				}
			},
			theme.title
		)
	}

	viewSubMenu() {
		const {theme_menu, channel, id, parentId} = this.attrs.data
		if (['policy_domain', 'policy_area'].indexOf(channel) < 0) return null
		const themeId = parentId ? parentId : id

		return (
			theme_menu.find(menu => menu.id == themeId).sub_menu[0] &&
			m('.theme-submenu', [
				theme_menu
					.find(menu => menu.id == themeId)
					.sub_menu.map(subtheme => [
						m(MediaQuery, {
							maxWidth: 1023,
							view: () => this.subTheme(subtheme, id, true)
						}),
						m(MediaQuery, {
							minWidth: 1024,
							view: () => this.subTheme(subtheme, id, false)
						})
					])
			])
		)
	}
	subTheme(subtheme, id, scrollTo) {
		return m('a.theme-submenu-item',
			{
				...action(subtheme.url),
				class: id == subtheme.id ? 'is-active activesubmenuitem' : ''
			},
			subtheme.title
		)
	}
}
